"use client"

import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle, DialogTrigger } from "../ui/dialog";
import { useState } from "react";
import { permaDeleteDomain } from "@/services/deletion.service";
import { DeleteView } from "@/app/deployment/delete/page";
import { DeletionStatus } from "@/constants/status";

interface Props {
    domain: DeleteView,
    updateData: () => void
}

export default function PermaDeleteDomainModal(props: Props) {
    const [open, setOpen] = useState(false)
    const [deletionStatus, setDeletionStatus] = useState(DeletionStatus.standBy);
    const [failedMessage, setFailedMessage] = useState("");

    async function handleOnSubmit(domainID: string){
        const formData = new FormData();
        formData.append('domainID', domainID);

        setDeletionStatus(DeletionStatus.onGoing);
        const status = await permaDeleteDomain(formData);

        if(status != "Permanent Deletion Complete"){
            console.log(status);
            setDeletionStatus(DeletionStatus.failed);
            setFailedMessage("Deletion failed. Check console.log for more information.<br>Otherwise, here: ".concat(status));
            return;
        }

        handleSuccess();
        return;
    }

    const handleSuccess = () => {
        setDeletionStatus(DeletionStatus.completed);
        setTimeout(() => {
            location.reload();
            props.updateData();
            setOpen(false);
        }, 3000);
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button className="cursor-pointer">Delete Domain</Button>
            </DialogTrigger>
            <DialogContent className="max-w-sm">
                <DialogTitle>Permanent Delete Domain</DialogTitle>
                <DialogDescription>
                    You sure you want to <b>Permanently</b> delete: {props.domain.Name}?
                </DialogDescription>
                <DialogFooter>
                    <div className="grid grid-cols-6 gap-4">
                        <div className="col-start-1 col-end-7 rounded-md border-black">
                            <Button className="cursor-pointer mb-3" onClick={(_e) => handleOnSubmit(props.domain.ID)}>Permanent Delete</Button>
                            {deletionStatus == DeletionStatus.onGoing && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Perma Deleting...</p>
                                </div>
                            )}
                            {deletionStatus == DeletionStatus.completed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Permanent Deletion complete! Will refresh this page momentarily</p>
                                </div>
                            )}
                            {deletionStatus == DeletionStatus.failed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>{failedMessage}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}